(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[14174,75413],{

/***/ 61748:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/e-ipo",
      function () {
        return __webpack_require__(33318);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ e_ipo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
// EXTERNAL MODULE: ./src/global/MainLayout/index.tsx + 4 modules
var MainLayout = __webpack_require__(53120);
// EXTERNAL MODULE: ./src/global/Securities/utils/maintenance.ts + 2 modules
var maintenance = __webpack_require__(38525);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/global/Modal/BaseConfirmationModal/index.tsx
var BaseConfirmationModal = __webpack_require__(51595);
;// CONCATENATED MODULE: ./src/features/eipo/utils/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1400px;\n  margin: auto;\n  padding-left: 5px;\n  padding-right: 5px;\n  border-radius: 2px;\n  border: 1px solid #ededed;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-body {\n    border-radius: 12px;\n  }\n\n  .ant-modal-close {\n    display: none;\n    visibility: hidden;\n    opacity: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-modal-body {\n    padding: 18px 0 8px;\n  }\n\n  & .base-modal-header {\n    margin-bottom: 18px;\n  }\n\n  & .button-row {\n    padding: 20px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 160px;\n  height: auto;\n\n  margin-bottom: 24px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n  margin-bottom: 16px;\n  white-space: pre-line;\n  text-align: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var EipoPageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2ecdbce4-0"
})(_templateObject());
var styled_Modal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-2ecdbce4-1"
})(_templateObject1());
var ModalSuccess = (0,styled_components_browser_esm/* default */.ZP)(BaseConfirmationModal/* default */.Z).withConfig({
    componentId: "sc-2ecdbce4-2"
})(_templateObject2());
var InfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2ecdbce4-3"
})(_templateObject3());
var Illustration = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-2ecdbce4-4"
})(_templateObject4());
var InfoText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-2ecdbce4-5"
})(_templateObject5());
/* harmony default export */ var styled = ({
    EipoPageContainer: EipoPageContainer,
    Modal: styled_Modal,
    ModalSuccess: ModalSuccess,
    InfoWrapper: InfoWrapper,
    Illustration: Illustration,
    InfoText: InfoText
});

;// CONCATENATED MODULE: ./src/features/eipo/components/eipo-detail/index.tsx





var IpoPage = dynamic_default()(// @ts-ignore
// eslint-disable-next-line
function() {
    return __webpack_require__.e(/* import() */ 73868).then(__webpack_require__.t.bind(__webpack_require__, 73868, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73868)
            ];
        }
    },
    ssr: false
});
var EipoPage = function(param) {
    var emiten = param.emiten, onClickListEmiten = param.onClickListEmiten;
    var onClickIpoChange = function(emitenCode) {
        onClickListEmiten(emitenCode);
    };
    var handleClickIPOLink = (0,react.useCallback)(function(event) {
        var data = event === null || event === void 0 ? void 0 : event.detail;
        if (data === null || data === void 0 ? void 0 : data.url) {
            var fullUrl = data.url;
            if (!fullUrl.startsWith("http://") && !fullUrl.startsWith("https://")) {
                fullUrl = "https://".concat(fullUrl);
            }
            window.open(fullUrl, "_blank");
        }
    }, []);
    var handleClickDetailIPO = (0,react.useCallback)(function(event) {
        var data = event === null || event === void 0 ? void 0 : event.detail;
        if ( true && data) {
            window.open("".concat(app/* PROJECT_FOLDER_PATH */.qV, "/symbol/").concat(data === null || data === void 0 ? void 0 : data.emiten), "_blank");
        }
    }, []);
    var handleOpenPDF = (0,react.useCallback)(function(event) {
        var data = event === null || event === void 0 ? void 0 : event.detail;
        if (data) {
            window.open(data.url).focus();
        }
    }, []);
    (0,react.useEffect)(function() {
        window.addEventListener("onclickIPOLink", handleClickIPOLink);
        window.addEventListener("openIPOPdf", handleOpenPDF);
        window.addEventListener("onclickDetailIPO", handleClickDetailIPO);
        return function() {
            window.removeEventListener("onclickIPOLink", handleClickIPOLink);
            window.removeEventListener("openIPOPdf", handleOpenPDF);
            window.removeEventListener("onclickDetailIPO", handleClickDetailIPO);
        };
    }, [
        handleClickIPOLink,
        handleOpenPDF
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EipoPageContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IpoPage, {
            emitenCode: emiten || "",
            onClickIpoChange: onClickIpoChange,
            isDark: false
        })
    });
};
/* harmony default export */ var eipo_detail = (EipoPage);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/TradingModal/hooks/useSyariah.ts
var useSyariah = __webpack_require__(47060);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/features/eipo/components/modal-success/index.tsx





var ModalSuccessInfo = function(_param) /*#__PURE__*/ {
    var _src = _param.src, src = _src === void 0 ? "/img/ipo-success.svg" : _src, _infoText = _param.infoText, infoText = _infoText === void 0 ? "Pemesanan Saham IPO STRK\nBerhasil Terkonfirmasi" : _infoText, _confirmText = _param.confirmText, confirmText = _confirmText === void 0 ? "Selesai" : _confirmText, props = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "infoText",
        "confirmText"
    ]);
    return (0,jsx_runtime.jsx)(ModalSuccess, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 400,
        hideCancelButton: true,
        confirmText: confirmText
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration, {
                    src: src
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoText, {
                    children: infoText
                })
            ]
        })
    }));
};
/* harmony default export */ var modal_success = (ModalSuccessInfo);

;// CONCATENATED MODULE: ./src/features/eipo/utils/constants.ts
var KEY_EVENT_OPEN_MODAL_BUY = "eipoOpenModalBuy";
var KEY_EVENT_CLOSE_MODAL_BUY = "eipoCloseModalBuy";
var KEY_EVENT_OPEN_MODAL_SUCCESS = "eipoOpenModalSuccess";
var KEY_EVENT_CLOSE_MODAL_SUCCESS = "eipoCloseModalSuccess";
var KEY_EVENT_OPEN_MODAL_DEPOSIT = "eipoOpenModalDeposit";
var KEY_EVENT_SHOW_TOAST_ERROR = "eipoShowToastError";

;// CONCATENATED MODULE: ./src/features/eipo/components/eipo-order/index.tsx











var IpoOrder = dynamic_default()(// @ts-ignore
// eslint-disable-next-line
function() {
    return __webpack_require__.e(/* import() */ 75662).then(__webpack_require__.t.bind(__webpack_require__, 75662, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75662)
            ];
        }
    },
    ssr: false
});
var EIpoOrder = function(param) {
    var emiten = param.emiten;
    var ref = (0,useSyariah/* default */.Z)(), isUserSyariah = ref.isUserSyariah, showSyariahRestrictionModal = ref.showSyariahRestrictionModal;
    var ref1 = (0,react.useState)({
        isOpen: false,
        content: ""
    }), modalSuccess = ref1[0], setModalSuccess = ref1[1];
    var ref2 = (0,react.useState)({
        emitenCode: null,
        state: null,
        isOpen: false
    }), modalInfo = ref2[0], setModalInfo = ref2[1];
    var onResetModalState = function() {
        var event = new CustomEvent("handleSetModalContent");
        window.dispatchEvent(event);
    };
    var listenOpenBuyModal = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        onResetModalState();
                        if (!event.detail) {
                            _ctx.next = 6;
                            break;
                        }
                        if (!(isUserSyariah && !event.detail.isSharia)) {
                            _ctx.next = 5;
                            break;
                        }
                        showSyariahRestrictionModal();
                        return _ctx.abrupt("return");
                    case 5:
                        setModalInfo({
                            emitenCode: event.detail.emiten,
                            state: event.detail.state,
                            isOpen: true
                        });
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        isUserSyariah
    ]);
    var listenCloseBuyModal = function() {
        setModalInfo({
            emitenCode: null,
            state: null,
            isOpen: false
        });
    };
    var closeBuyModal = function() {
        setModalInfo({
            emitenCode: null,
            state: null,
            isOpen: false
        });
        onResetModalState();
    };
    var listenOpenSuccessModal = function(event) {
        if (event.detail) {
            setModalSuccess({
                isOpen: true,
                content: event.detail
            });
        }
    };
    var closeSuccessModal = function() {
        var event = new CustomEvent(KEY_EVENT_CLOSE_MODAL_SUCCESS);
        window.dispatchEvent(event);
        setModalSuccess({
            isOpen: false,
            content: ""
        });
    };
    var listenOpenModalDeposit = function() {
        if (true) {
            window.open("/securities/deposit/", "_blank");
        }
    };
    var listenToastError = function(event) {
        if (event.detail) {
            (0,AlertErrorMessage/* default */.Z)(event.detail.message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
        }
    };
    (0,react.useEffect)(function() {
        window.addEventListener(KEY_EVENT_OPEN_MODAL_BUY, listenOpenBuyModal);
        window.addEventListener(KEY_EVENT_CLOSE_MODAL_BUY, listenCloseBuyModal);
        window.addEventListener(KEY_EVENT_OPEN_MODAL_SUCCESS, listenOpenSuccessModal);
        window.addEventListener(KEY_EVENT_OPEN_MODAL_DEPOSIT, listenOpenModalDeposit);
        window.addEventListener(KEY_EVENT_SHOW_TOAST_ERROR, listenToastError);
        return function() {
            window.removeEventListener(KEY_EVENT_OPEN_MODAL_BUY, listenOpenBuyModal);
            window.removeEventListener(KEY_EVENT_CLOSE_MODAL_BUY, listenCloseBuyModal);
            window.removeEventListener(KEY_EVENT_OPEN_MODAL_SUCCESS, listenOpenSuccessModal);
            window.removeEventListener(KEY_EVENT_OPEN_MODAL_DEPOSIT, listenOpenModalDeposit);
            window.removeEventListener(KEY_EVENT_SHOW_TOAST_ERROR, listenToastError);
        };
    }, [
        listenOpenBuyModal
    ]);
    var showContent = modalInfo.isOpen && modalInfo.emitenCode !== null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Modal, {
                visible: showContent,
                onCancel: closeBuyModal,
                closable: false,
                width: 480,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IpoOrder, {
                    emitenCode: modalInfo.emitenCode,
                    state: modalInfo.state,
                    isDark: false
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_success, {
                visible: modalSuccess.isOpen,
                onCancel: closeSuccessModal,
                onConfirm: closeSuccessModal,
                infoText: modalSuccess.content
            })
        ]
    });
};
/* harmony default export */ var eipo_order = (EIpoOrder);

// EXTERNAL MODULE: ./src/features/securities/AuthModal/utils.ts
var utils = __webpack_require__(24293);
// EXTERNAL MODULE: ./src/features/securities/styled.ts
var securities_styled = __webpack_require__(38639);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/store.ts
var store = __webpack_require__(70175);
// EXTERNAL MODULE: ./src/hooks/useTradingAccount.ts
var useTradingAccount = __webpack_require__(64999);
// EXTERNAL MODULE: ./src/utils/securitiesLocalStorage.ts + 1 modules
var securitiesLocalStorage = __webpack_require__(11763);
// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/errorboundary.js + 1 modules
var errorboundary = __webpack_require__(94787);
// EXTERNAL MODULE: ./src/global/ErrorBoundary/ErrorFallback.tsx + 1 modules
var ErrorFallback = __webpack_require__(59735);
;// CONCATENATED MODULE: ./pages/e-ipo/index.tsx

__webpack_require__(14473);
















var EIpoProvider = dynamic_default()(// @ts-ignore
// eslint-disable-next-line
function() {
    return __webpack_require__.e(/* import() */ 72382).then(__webpack_require__.t.bind(__webpack_require__, 72382, 23)).catch(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Error"
        });
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72382)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return null;
    }
});
var FallbackRenderer = function(fallbackProps) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            padding: "20px",
            height: "calc(100vh - 200px)"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorFallback/* default */.Z, {
            errorData: fallbackProps
        })
    });
};
var EIPO = function() {
    var router = (0,next_router.useRouter)();
    var showAuthModal = (0,store/* default */.Z)(function(state) {
        return state.showModal;
    });
    var ref = (0,react.useState)(""), currentEmiten = ref[0], setCurrentEmiten = ref[1];
    var ref1 = (0,useTradingAccount/* default */.Z)(), isRealTrading = ref1.isRealTrading, isVirtualTrading = ref1.isVirtualTrading, tradingType = ref1.tradingType;
    var isLoggedInSekuritas = securitiesLocalStorage/* default.getSecuritiesToken */.Z.getSecuritiesToken().securitiesAccessToken;
    var handleChangeRouter = function(emiten) {
        setCurrentEmiten(emiten);
        router.replace({
            query: {
                emiten: emiten
            }
        });
    };
    var checkSekuritasLogin = function() {
        if (!isLoggedInSekuritas) {
            (0,maintenance/* withMaintenanceGuard */.L)(function() {
                (0,utils/* showTradingModalWithAuth */.Y)({});
            });
        }
    };
    (0,react.useEffect)(function() {
        var emiten = router.query.emiten;
        if (emiten !== undefined) {
            setCurrentEmiten(emiten.toString());
        }
        checkSekuritasLogin();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "Stockbit e-IPO"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout["default"], {
                isFlexibleWidth: true,
                maxWidth: 1036,
                children: [
                    isRealTrading && /*#__PURE__*/ (0,jsx_runtime.jsx)(errorboundary/* ErrorBoundary */.SV, {
                        fallback: FallbackRenderer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                            fallback: null,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EIpoProvider, {
                                isDark: false,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(eipo_detail, {
                                        onClickListEmiten: handleChangeRouter,
                                        emiten: currentEmiten
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(eipo_order, {
                                        emiten: currentEmiten
                                    })
                                ]
                            })
                        })
                    }),
                    (isVirtualTrading || !tradingType) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                        align: "center",
                        justify: "center",
                        height: "calc(100vh - 200px)",
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/illustration/eipo-login.svg",
                                    alt: "Eipo Login Illustration",
                                    width: "138",
                                    height: "120"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return showAuthModal();
                                        },
                                        style: {
                                            color: "#0BA16B",
                                            cursor: "pointer",
                                            border: "none",
                                            background: "none",
                                            display: "inline",
                                            fontWeight: 700
                                        },
                                        type: "button",
                                        children: "Login"
                                    }),
                                    " ",
                                    "to view e-IPO"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var e_ipo = (EIPO);


/***/ }),

/***/ 54855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ AUTH_MODAL_CONFIG; },
/* harmony export */   "q": function() { return /* binding */ AUTH_ORDER_TYPE; }
/* harmony export */ });
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83153);

var AUTH_ORDER_TYPE = {
    BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY,
    SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL,
    AMEND_BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY,
    AMEND_SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL
};
var AUTH_MODAL_CONFIG = {
    real: {
        BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY,
        SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL,
        AMEND_BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY,
        AMEND_SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL
    },
    virtual: {
        BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_BUY */ .Jm.VIRTUAL_BUY,
        SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_SELL */ .Jm.VIRTUAL_SELL,
        AMEND_BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_AMEND_BUY */ .Jm.VIRTUAL_AMEND_BUY,
        AMEND_SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_AMEND_SELL */ .Jm.VIRTUAL_AMEND_SELL
    }
};


/***/ }),

/***/ 70175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var useAuthModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        visible: false,
        tradingModalConfig: null,
        showModal: function() {
            var tradingModalConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            set({
                tradingModalConfig: tradingModalConfig,
                visible: true
            });
        },
        closeModal: function() {
            set({
                tradingModalConfig: null,
                visible: false
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useAuthModalStore);


/***/ }),

/***/ 24293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ showTradingModalWithAuth; }
/* harmony export */ });
/* unused harmony export getAuthModalError */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var global_TradingModal_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70362);
/* harmony import */ var utils_securitiesLocalStorage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11763);
/* harmony import */ var global_MainLayout_ModalErrorMessage_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5728);
/* harmony import */ var lib_stores_multiPorto__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34385);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70175);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54855);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4621);











var showTradingModalWithAuth = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tradingModalConfig, needLoginCallback) {
        var tradingType, showAuthModal, showTradingModal, getTradingBalance, res;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    tradingType = utils_securitiesLocalStorage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getTradingAccountType */ .Z.getTradingAccountType();
                    showAuthModal = _store__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getState */ .Z.getState().showModal;
                    showTradingModal = global_TradingModal_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState().showModal;
                    getTradingBalance = lib_stores_multiPorto__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getState */ .Z.getState().getTradingBalance;
                    if (tradingType) {
                        _ctx.next = 8;
                        break;
                    }
                    showAuthModal(tradingModalConfig);
                    if (needLoginCallback) {
                        needLoginCallback();
                    }
                    return _ctx.abrupt("return");
                case 8:
                    if (!(tradingType === "virtual")) {
                        _ctx.next = 11;
                        break;
                    }
                    showTradingModal((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, tradingModalConfig), {
                        orderType: _constants__WEBPACK_IMPORTED_MODULE_6__/* .AUTH_MODAL_CONFIG */ .n[tradingType][tradingModalConfig.orderType]
                    }));
                    return _ctx.abrupt("return");
                case 11:
                    _ctx.next = 13;
                    return getTradingBalance();
                case 13:
                    res = _ctx.sent;
                    if (res === null || res === void 0 ? void 0 : res.aggregated_portfolio_summary) {
                        showTradingModal((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, tradingModalConfig), {
                            orderType: _constants__WEBPACK_IMPORTED_MODULE_6__/* .AUTH_MODAL_CONFIG */ .n[tradingType][tradingModalConfig.orderType]
                        }));
                    }
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function showTradingModalWithAuth(tradingModalConfig, needLoginCallback) {
        return _ref.apply(this, arguments);
    };
}();
var getAuthModalError = function(errorCode, errorType) {
    var ref;
    if (isNewCoreUser() && errorType) {
        return errorType !== "INVALID_CREDS";
    }
    var errorTradingModalConfig = tradingErrorModalList === null || tradingErrorModalList === void 0 ? void 0 : (ref = tradingErrorModalList[errorCode]) === null || ref === void 0 ? void 0 : ref[errorType];
    return !!errorTradingModalConfig;
};


/***/ }),

/***/ 38639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C3": function() { return /* binding */ ContainerTemplateWrapper; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "l2": function() { return /* binding */ UserRdnInfoContainer; }
/* harmony export */ });
/* unused harmony exports PageContainer, CarouselContainer, RightSection, VirtualButtonContainer, Carousel, CarouselItemContainer, CarouselImage, VirtualButton, LoginButton, RegisterButton, Input, InputPINForm, InputPINContainer, RegisterContainer, BannerRegisterContainer, BackButton, InfoRegisterContainer, Iconmoon, GrayBackButton, ProfileLabel, ProfileInputGroup, InputTokenContainer */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54325);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74575);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61980);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71230);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(579);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  overflow-y: hidden;\n  position: relative;\n  margin-top: 60px;\n  height: calc(100vh - 60px);\n\n  @media ",
        " {\n    margin-top: 103px;\n    height: calc(100vh - 103px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    background: #5dcbad26;\n    padding: 30px;\n    height: calc(100vh - 60px);\n    max-height: 100%;\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  background: ",
        ";\n  padding: 30px;\n  overflow-y: auto;\n\n  @media ",
        " {\n    /* height: 95vh;\n    max-height: 100%; */\n    height: calc(100vh - 101px);\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 300px;\n  margin-bottom: 50px;\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 50px;\n  height: 100%;\n  max-height: 550px;\n  margin-top: 23%;\n\n  .slick-dots {\n    width: auto;\n    bottom: -60px;\n\n    li {\n      width: unset;\n    }\n\n    li button {\n      background: gray;\n      width: 5px;\n      height: 5px;\n      border-radius: 10px;\n\n      &::before {\n        display: none;\n      }\n    }\n\n    li.slick-active button {\n      width: 25px;\n      height: 5px;\n      background: ",
        ";\n      border: unset;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 240px;\n  margin: auto;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 auto 25px;\n  width: 180px;\n  height: 180px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 20px auto;\n  padding: 10px 15px;\n  border-radius: 10px;\n  background: transparent;\n\n  img {\n    margin-right: 10px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 5px;\n  width: 100%;\n  margin: 5px 0;\n\n  @media ",
        " {\n    width: 268px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 5px;\n  width: 100%;\n  margin: 5px 0;\n  padding: 6px;\n  border: 1px solid ",
        ";\n\n  @media ",
        " {\n    width: 268px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &\n    .ant-form-item-has-error\n    .ant-input-affix-wrapper-focused.securities-input-pin,\n  & .ant-form-item-has-error .ant-input-affix-wrapper,\n  & .ant-form-item-has-error .securities-input-pin:hover {\n    border-color: ",
        " !important;\n    box-shadow: none;\n  }\n\n  & .ant-form-item-explain.ant-form-item-explain-error {\n    margin-top: 4px;\n    min-height: 19px;\n\n    div {\n      display: flex;\n      align-items: center;\n      font-size: 12px;\n      line-height: 1.5;\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n\n  .eye {\n    position: absolute;\n    right: 10px;\n    width: 16px;\n    cursor: pointer;\n  }\n\n  .withdrawal-input-pin {\n    padding: 0;\n\n    &.ant-input-affix-wrapper {\n      padding: 0;\n      margin-bottom: 4px;\n    }\n\n    .ant-input-prefix {\n      background: ",
        ";\n      margin-right: 12px;\n      padding: 11px;\n      border-right: 1px solid ",
        ";\n    }\n  }\n\n  .ant-input-group-addon {\n    background: ",
        ";\n  }\n\n  .securities-input-pin {\n    margin: 15px 0 5px;\n    height: 35px;\n    padding-left: 45px;\n\n    &::placeholder {\n      font-family: var(--bold-font);\n      color: #e4e4e4;\n    }\n\n    &.ant-input-affix-wrapper-focused {\n      border-color: ",
        ";\n      box-shadow: none;\n    }\n  }\n\n  .ant-input-group .ant-input {\n    width: 85%;\n  }\n\n  .icon-password.input-prefix {\n    position: absolute;\n    top: 15px;\n    left: 0;\n    width: 35px;\n    height: 35px;\n    text-align: center;\n    line-height: 35px;\n    border-right: 1px solid ",
        ";\n    z-index: 2;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  height: 585px;\n  max-width: 798px;\n  margin: 20px auto;\n  background: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  position: relative;\n  width: 40%;\n  padding: 20px;\n\n  img {\n    position: absolute;\n    right: 0;\n    top: 170px;\n  }\n\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  height: 35px;\n  padding: 20px;\n  border: 1px solid ",
        ";\n  border-radius: 3px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  padding: 0px 40px;\n  border-left: 1px solid ",
        ";\n  height: 100%;\n  background: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &:before {\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  position: absolute;\n  top: 25px;\n  left: 20px;\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  margin: 0 auto;\n  height: fit-content;\n  border-radius: 4px;\n  width: ",
        ";\n\n  &.deposit-section-instruction {\n    border: none;\n    border-radius: 0;\n    min-height: 100%;\n\n    i.icon-up-arrow {\n      transform: rotate(-90deg);\n      font-size: 14px;\n      color: ",
        ";\n    }\n  }\n\n  .header {\n    height: 56px;\n    padding: 0 20px;\n    border-bottom: 1px solid ",
        ";\n\n    p {\n      margin-bottom: 0;\n    }\n\n    .back-btn {\n      background: none;\n      border: none;\n      min-width: 30px;\n      width: fit-content;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      padding: 0;\n    }\n\n    .title {\n      font-family: var(--bold-font);\n      font-size: 18px;\n      line-height: 24px;\n      text-align: center;\n      color: ",
        ";\n    }\n\n    .right-header {\n      text-align: right;\n\n      .history-link {\n        font-size: 18px;\n        line-height: 24px;\n        text-align: right;\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-wrap: nowrap;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  padding: ",
        ";\n  text-align: left;\n\n  img {\n    display: block;\n    width: 40px;\n    height: 40px;\n    border-radius: 20px;\n  }\n\n  .text-content {\n    flex-grow: 1;\n    font-size: 14px;\n    line-height: 19px;\n    padding: 0 16px;\n    overflow: hidden;\n\n    p {\n      margin-bottom: 0;\n      line-height: 21px;\n    }\n\n    .rdn-name {\n      color: ",
        ";\n      word-break: break-word;\n      margin-bottom: 4px;\n    }\n\n    .rdn-account {\n      font-family: var(--bold-font);\n      color: ",
        ";\n      font-size: 13.5px;\n    }\n  }\n\n  .btn-copy {\n    background-color: #ebf6ef;\n    font-size: 14px;\n    line-height: 17px;\n    letter-spacing: 0.02em;\n    color: ",
        ";\n    padding: 8px 10px;\n    border-radius: 4px;\n    border: none;\n    font-family: var(--bold-font);\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: 16px;\n  width: 30%;\n  color: ",
        ";\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  margin: 25px 0;\n  width: 100%;\n\n  &.small-margin {\n    margin: 5px 0;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .input-token {\n    border: 1px solid ",
        ";\n    height: 36px;\n    input {\n      border: none;\n      font-size: 16px;\n      padding: 5px;\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}









var Flex = _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z;
var PageContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-0"
})(_templateObject(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var CarouselContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-1"
})(_templateObject1(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet, function(props) {
    return props.width ? props.width : "100%";
});
var RightSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-2"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet, function(props) {
    return props.width ? props.width : "100%";
});
var VirtualButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-182c06c0-3"
})(_templateObject3(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var Carousel = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-4"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
var CarouselItemContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-5"
})(_templateObject5());
var CarouselImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(global_Image__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-6"
})(_templateObject6());
var VirtualButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-7"
})(_templateObject7());
var LoginButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-8"
})(_templateObject8(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var RegisterButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-9"
})(_templateObject9(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-10"
})(_templateObject10());
var InputPINForm = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-11"
})(_templateObject11(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].sunsetOrange */ .Z.sunsetOrange);
var InputPINContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-182c06c0-12"
})(_templateObject12(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro);
var RegisterContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-13"
})(_templateObject13(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].downgray */ .Z.downgray);
var BannerRegisterContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-182c06c0-14"
})(_templateObject14(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var BackButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-15"
})(_templateObject15(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
var InfoRegisterContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-16"
})(_templateObject16(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light);
var Iconmoon = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-17"
})(_templateObject17(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
var GrayBackButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-18"
})(_templateObject18(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var ContainerTemplateWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-19"
})(_templateObject19(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var width = param.width;
    if (typeof width === "number") return "".concat(width, "px");
    return width;
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].midgray */ .Z.midgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].highempahis */ .Z.highempahis, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
var UserRdnInfoContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-20"
})(_templateObject20(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].downgray */ .Z.downgray, function(param) {
    var padding = param.padding;
    if (padding) {
        if (typeof padding === "number") return "".concat(padding, "px");
        return padding;
    }
    return "16px 24px";
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].highgray */ .Z.highgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].highempahis */ .Z.highempahis, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
var ProfileLabel = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-182c06c0-21"
})(_templateObject21(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].highempahis */ .Z.highempahis);
var ProfileInputGroup = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-22"
})(_templateObject22());
var InputTokenContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-23"
})(_templateObject23(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro);


/***/ }),

/***/ 59735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ErrorBoundary_ErrorFallback; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/ErrorBoundary/ErrorFallback.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 8px;\n\n  p {\n    font-size: 0.8125rem;\n    font-weight: 400;\n    line-height: 18px;\n    color: #333333;\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 120px;\n\n  img {\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 18px;\n  color: #00AB6B;\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var ErrorContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14f2b932-0"
})(_templateObject());
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14f2b932-1"
})(_templateObject1());
var RetryButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14f2b932-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/global/ErrorBoundary/ErrorFallback.tsx



var ErrorFallback = function(param) {
    var errorData = param.errorData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorContainer, {
        className: "error-fallback",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: "",
                    src: "/images/empty-ufo.svg",
                    width: 120
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Load failed, please retry."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RetryButton, {
                onClick: function() {
                    return errorData.resetError();
                },
                children: "Retry"
            })
        ]
    });
};
/* harmony default export */ var ErrorBoundary_ErrorFallback = (ErrorFallback);


/***/ }),

/***/ 79928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CloseSvg = function(param) {
    var _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _stroke = param.stroke, stroke = _stroke === void 0 ? "currentColor" : _stroke, _width = param.width, width = _width === void 0 ? "1em" : _width, _height = param.height, height = _height === void 0 ? "1em" : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 12 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11 1.5L1 11.5",
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1 1.5L11 11.5",
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseSvg);


/***/ }),

/***/ 5728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ar": function() { return /* binding */ tradingErrorModalList; },
/* harmony export */   "c0": function() { return /* binding */ tradingErrorModalConfig; },
/* harmony export */   "qO": function() { return /* binding */ errorInfoList; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var errorInfoList = [
    {
        error: 401,
        imageUrl: "/img/session-time-out.svg",
        title: "Sesi Kamu Sudah Habis",
        description: "Silahkan login kembali untuk melanjutkan",
        isShowButton: true,
        buttonText: "Kembali ke Halaman Utama",
        isLogoutUser: true
    },
    {
        error: 500,
        imageUrl: "/img/internal-server-error.svg",
        title: "Kendala pada Server",
        description: "Jangan khawatir, tim kami sedang memperbaikinya. Silakan coba lagi nanti.",
        isShowButton: true,
        buttonText: "Tutup"
    },
    {
        error: 503,
        imageUrl: "/img/maintenance-mode.svg",
        title: "Maintenance Sedang Berlangsung",
        description: "Stockbit sedang menjalankan maintenance, cobalah beberapa saat lagi.",
        isShowButton: true,
        buttonText: "Kembali ke Halaman Utama"
    }, 
];
var tradingErrorModalConfig = {
    sessionExpired: {
        imageUrl: "/img/session-time-out.svg",
        title: "Sesi Kamu Sudah Habis",
        description: "Silahkan login kembali untuk melanjutkan",
        buttonText: "Kembali ke Halaman Utama",
        isShowButton: true,
        isLogoutUser: true
    },
    maintenance: {
        imageUrl: "/img/maintenance-mode.svg",
        title: "Pemeliharaan Sedang Berlangsung",
        buttonText: "Kembali ke Halaman Utama",
        isShowButton: false
    },
    dailyMaintenance: {
        imageUrl: "/img/daily-maintenance.svg",
        title: "Persiapan Harian",
        buttonText: "Kembali ke Halaman Utama",
        isShowButton: false
    },
    systemError: {
        imageUrl: "/img/internal-server-error.svg",
        title: "Kendala pada Server",
        description: "Jangan khawatir, tim kami sedang memperbaikinya. Silakan coba lagi nanti.",
        buttonText: "Tutup",
        isShowButton: true
    },
    userSuspend: {
        imageUrl: "/img/trading-limit-user-suspended.svg",
        title: "Tidak Dapat Melakukan Transaksi",
        description: "Deposit atau jual saham untuk melakukan transaksi.",
        buttonText: "Deposit Sekarang",
        isShowButton: true,
        redirectTo: "/securities/deposit",
        needToCloseTradingModal: true,
        isFullWidthButton: true
    }
};
var tradingErrorModalList = {
    401: {
        NO_SERVER_RESPONSE: "sessionExpired",
        INVALID_AUTH: "sessionExpired",
        // checkov:skip=<CKV_SECRET_6> "false positive, no secret TOKEN exposed here"
        INVALID_TOKEN: "sessionExpired",
        INVALID_SESSION: "sessionExpired",
        MOCK_TRADING: "sessionExpired",
        MAINTENANCE_MODE: "maintenance",
        DAILY_MAINTENANCE_MODE: "dailyMaintenance",
        UNAUTHORIZED: "sessionExpired"
    },
    403: {
        USER_SUSPEND: "userSuspend",
        USER_SUSPEND_BACK_OFFICE: "userSuspend"
    },
    503: {
        MAINTENANCE_MODE: "maintenance",
        DAILY_MAINTENANCE_MODE: "dailyMaintenance"
    },
    500: {
        SYSTEM_ERROR: "systemError"
    }
};


/***/ }),

/***/ 51595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15746);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65344);
/* harmony import */ var _BaseModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16981);







var BaseConfirmationModal = function(_param) /*#__PURE__*/ {
    var description = _param.description, _cancelText = _param.cancelText, cancelText = _cancelText === void 0 ? "Cancel" : _cancelText, _confirmText = _param.confirmText, confirmText = _confirmText === void 0 ? "Confirm" : _confirmText, _hideSubmitButton = _param.hideSubmitButton, hideSubmitButton = _hideSubmitButton === void 0 ? false : _hideSubmitButton, _hideCancelButton = _param.hideCancelButton, hideCancelButton = _hideCancelButton === void 0 ? false : _hideCancelButton, _onConfirm = _param.onConfirm, onConfirm = _onConfirm === void 0 ? function() {} : _onConfirm, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "description",
        "cancelText",
        "confirmText",
        "hideSubmitButton",
        "hideCancelButton",
        "onConfirm",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_BaseModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        children: [
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .DescriptionRow */ .uw, {
                className: "description",
                align: "middle",
                justify: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    span: 24,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .Description */ .dk, {
                        children: description
                    })
                })
            }),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .ButtonRow */ .VR, {
                className: "button-row",
                gutter: 16,
                children: [
                    !hideCancelButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: hideSubmitButton ? 24 : 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .CancelButton */ .Lw, {
                            onClick: props.onCancel,
                            block: true,
                            children: cancelText
                        })
                    }),
                    !hideSubmitButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: hideCancelButton ? 24 : 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .ConfirmButton */ .pu, {
                            type: "primary",
                            onClick: onConfirm,
                            loading: props.confirmLoading,
                            block: true,
                            children: confirmText
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseConfirmationModal);


/***/ }),

/***/ 65344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lw": function() { return /* binding */ CancelButton; },
/* harmony export */   "VR": function() { return /* binding */ ButtonRow; },
/* harmony export */   "dk": function() { return /* binding */ Description; },
/* harmony export */   "pu": function() { return /* binding */ ConfirmButton; },
/* harmony export */   "uw": function() { return /* binding */ DescriptionRow; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71577);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 12px 20px;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  color: #858585;\n  text-align: center;\n\n  margin: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 40px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 44px;\n  border: 1px solid #ededed;\n  border-radius: 4px;\n  color: #333333;\n\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n\n  padding: 12px 20px;\n\n  &:hover,\n  &:active,\n  &:focus {\n    color: #333333;\n    border-color: #ededed;\n  }\n\n  &::after {\n    box-shadow: 0 0 0 0 #000000 !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 44px;\n  color: #ffffff;\n  border-radius: 4px;\n\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n\n  padding: 12px 20px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var DescriptionRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7df14943-0"
})(_templateObject());
var Description = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-7df14943-1"
})(_templateObject1());
var ButtonRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7df14943-2"
})(_templateObject2());
var CancelButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7df14943-3"
})(_templateObject3());
var ConfirmButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7df14943-4"
})(_templateObject4());


/***/ }),

/***/ 16981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16165);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15746);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71230);
/* harmony import */ var global_Icons_CloseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79928);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89997);








var BaseModal = function(_param) /*#__PURE__*/ {
    var prefix = _param.prefix, title = _param.title, children = _param.children, _closable = _param.closable, closable = _closable === void 0 ? true : _closable, _hideHeader = _param.hideHeader, hideHeader = _hideHeader === void 0 ? false : _hideHeader, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "prefix",
        "title",
        "children",
        "closable",
        "hideHeader"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u_, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        centered: true,
        footer: null
    }, props), {
        closable: false,
        children: [
            !hideHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .HeaderRow */ .VJ, {
                className: "base-modal-header",
                align: "middle",
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: 1,
                        children: prefix
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: 22,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            align: "middle",
                            justify: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, {
                                    className: "base-modal-title",
                                    children: title
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: 1,
                        children: closable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .CloseButton */ .PZ, {
                            onClick: props.onCancel,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                style: {
                                    fontSize: 10,
                                    color: "#969696"
                                },
                                component: global_Icons_CloseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
                            })
                        })
                    })
                ]
            }),
            children
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseModal);


/***/ }),

/***/ 89997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "PZ": function() { return /* binding */ CloseButton; },
/* harmony export */   "VJ": function() { return /* binding */ HeaderRow; },
/* harmony export */   "u_": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33070);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71230);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & .ant-modal-content {\n    border-radius: 3px;\n  }\n  & .ant-modal-body {\n    padding: 24px 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 22px;\n  padding: 0 20px;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n\n  margin: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n\n  width: 24px;\n  height: 24px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-90095253-0"
})(_templateObject());
var HeaderRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-90095253-1"
})(_templateObject1());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-90095253-2"
})(_templateObject2());
var CloseButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-90095253-3"
})(_templateObject3());


/***/ }),

/***/ 54154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ glossaryMetaTags; },
/* harmony export */   "x": function() { return /* binding */ defaultMetaTags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var defaultMetaTags = {
    title: "Stockbit - Investasi Saham Bersama Komunitas Saham Terbesar di Indonesia",
    description: "Aplikasi saham untuk berdiskusi, analisa dan berinvestasi dengan harga real time, berita terkini, riset, data fundamental, charting, dan analytical tools yang lengkap",
    keywords: "stockbit, investasi, saham, pasar modal, pasar saham, harga saham, belajar investasi, belajar saham, nabung saham, rekomendasi saham, belajar trading, virtual trading, komunitas saham, ihsg, berita saham, analisa saham, jual beli saham, bei, bursa saham indonesia, idx, professional tools, tools saham, saham bumi, reksadana, jkse",
    image: "https://stockbit.com/assets/img/stockbit.jpg",
    url: "https://stockbit.com"
};
var glossaryMetaTags = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, defaultMetaTags), {
    title: "Stockbit Glossary | Stockbit - Kamus Investasi Saham",
    url: "https://stockbit.com/glossary"
});
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 26350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86123);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54154);







function SEO(param) {
    var title = param.title, description = param.description, keywords = param.keywords, image = param.image, url = param.url, schemaJson = param.schemaJson, customTitle = param.customTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title !== _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title && !schemaJson && !customTitle ? "".concat(title, " | ").concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title) : title
            }),
            constants_app__WEBPACK_IMPORTED_MODULE_2__/* .isProduction */ .yv ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit-after",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "resource-type",
                content: "document"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "audience",
                content: "general"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "content-language",
                content: "id-ID"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "web_author",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "copyright",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google",
                content: "notranslate"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "n9LVcB1gB0We60y2dG78-koFgM8y_mrf9pw1hrKsxFA"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "fb:app_id",
                content: constants_api__WEBPACK_IMPORTED_MODULE_1__/* .FACEBOOK_APP_ID */ .lZ
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            schemaJson ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schemaJson)
                }
            }) : null
        ]
    });
}
SEO.defaultProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags */ .x), {
    customTitle: false
});
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 96563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ tradingApiInstance; },
/* harmony export */   "j": function() { return /* binding */ getTradingApiInstance; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18364);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83153);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4621);





var _obj;
var tradingApiInstance = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.LEGACY */ .FA.LEGACY, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL */ .Cb, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.NEW_CORE */ .FA.NEW_CORE, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "general", (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg)), _obj);
var getTradingApiInstance = function() {
    var targetAPI = (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTargetAPI */ .Ai)();
    return tradingApiInstance[targetAPI];
};


/***/ }),

/***/ 75626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ OrderAction; }
/* harmony export */ });
/* unused harmony export OrderStatus */
var OrderAction;
(function(OrderAction) {
    OrderAction["Buy"] = "BUY";
    OrderAction["Sell"] = "SELL";
})(OrderAction || (OrderAction = {}));
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["Ready"] = "READY";
    OrderStatus["Open"] = "OPEN";
    OrderStatus["Partial"] = "PARTIAL";
    OrderStatus["Rejected"] = "REJECTED";
    OrderStatus["Pending"] = "PENDING";
    OrderStatus["Active"] = "ACTIVE";
    OrderStatus["RequestAmend"] = "REQUEST AMEND";
})(OrderStatus || (OrderStatus = {}));


/***/ }),

/***/ 91037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BJ": function() { return /* binding */ ActionTarget; },
/* harmony export */   "F4": function() { return /* binding */ PlatformOrderTypes; },
/* harmony export */   "IC": function() { return /* binding */ OrderSecuritiesKindType; },
/* harmony export */   "iX": function() { return /* binding */ OrderAction; },
/* harmony export */   "l5": function() { return /* binding */ ForcedSellMapper; },
/* harmony export */   "oU": function() { return /* binding */ OrderSide; },
/* harmony export */   "pD": function() { return /* binding */ OrderForceSellType; },
/* harmony export */   "pY": function() { return /* binding */ SecuritiesKind; },
/* harmony export */   "vT": function() { return /* binding */ iOrderSide; }
/* harmony export */ });
/* unused harmony exports OrderStatus, LeverageType */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var SecuritiesKind;
(function(SecuritiesKind) {
    SecuritiesKind[SecuritiesKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    SecuritiesKind[SecuritiesKind["STOCK"] = 1] = "STOCK";
    SecuritiesKind[SecuritiesKind["BOND"] = 2] = "BOND";
})(SecuritiesKind || (SecuritiesKind = {}));
var OrderSecuritiesKindType;
(function(OrderSecuritiesKindType) {
    OrderSecuritiesKindType["Unspecified"] = "SECURITIES_KIND_UNSPECIFIED";
    OrderSecuritiesKindType["Stock"] = "SECURITIES_KIND_STOCK";
    OrderSecuritiesKindType["Bond"] = "SECURITIES_KIND_BOND";
})(OrderSecuritiesKindType || (OrderSecuritiesKindType = {}));
var PlatformOrderTypes;
(function(PlatformOrderTypes) {
    PlatformOrderTypes["UNSPECIFIED"] = "PLATFORM_ORDER_TYPE_UNSPECIFIED";
    PlatformOrderTypes["LIMIT"] = "PLATFORM_ORDER_TYPE_LIMIT_DAY";
    PlatformOrderTypes["FAK"] = "PLATFORM_ORDER_TYPE_MARKET_FAK";
    PlatformOrderTypes["FAST_ORDER"] = "PLATFORM_ORDER_TYPE_FAST_ORDER";
})(PlatformOrderTypes || (PlatformOrderTypes = {}));
var OrderAction;
(function(OrderAction) {
    OrderAction["Buy"] = "BUY";
    OrderAction["Sell"] = "SELL";
})(OrderAction || (OrderAction = {}));
var iOrderSide;
(function(iOrderSide) {
    iOrderSide[iOrderSide["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    iOrderSide[iOrderSide["BUY"] = 1] = "BUY";
    iOrderSide[iOrderSide["SELL"] = 2] = "SELL";
})(iOrderSide || (iOrderSide = {}));
var OrderSide;
(function(OrderSide) {
    OrderSide["Unspecified"] = "SIDE_UNSPECIFIED";
    OrderSide["Buy"] = "SIDE_BUY";
    OrderSide["Sell"] = "SIDE_SELL";
})(OrderSide || (OrderSide = {}));
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["Ready"] = "READY";
    OrderStatus["Open"] = "OPEN";
    OrderStatus["Partial"] = "PARTIAL";
    OrderStatus["Rejected"] = "REJECTED";
    OrderStatus["Pending"] = "PENDING";
    OrderStatus["Active"] = "ACTIVE";
    OrderStatus["RequestAmend"] = "REQUEST AMEND";
})(OrderStatus || (OrderStatus = {}));
var OrderForceSellType;
(function(OrderForceSellType) {
    OrderForceSellType["Unspecified"] = "DAY_TRADE_FORCE_SELL_UNSPECIFIED";
    OrderForceSellType["DebtRatio"] = "DAY_TRADE_FORCE_SELL_DEBT_RATIO";
    OrderForceSellType["TimeLimit"] = "DAY_TRADE_FORCE_SELL_TIME_LIMIT";
})(OrderForceSellType || (OrderForceSellType = {}));
var LeverageType;
(function(LeverageType) {
    LeverageType["Unspecified"] = "LEVERAGE_TYPE_TRADING_UNSPECIFIED";
    LeverageType["TradingBalance"] = "LEVERAGE_TYPE_TRADING_BALANCE";
    LeverageType["TradingLimit"] = "LEVERAGE_TYPE_TRADING_LIMIT";
    LeverageType["BasicLimit"] = "LEVERAGE_TYPE_BASIC_LIMIT";
    LeverageType["TempLimit"] = "LEVERAGE_TYPE_TEMP_LIMIT";
    LeverageType["DayTrade"] = "LEVERAGE_TYPE_DAY_TRADE";
})(LeverageType || (LeverageType = {}));
var _obj;
var ForcedSellMapper = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, OrderForceSellType.DebtRatio, "FORCED SELL"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, OrderForceSellType.TimeLimit, "FORCED SELL"), _obj);
var ActionTarget;
(function(ActionTarget) {
    ActionTarget["UNSPECIFIED"] = "ACTION_TARGET_UNSPECIFIED";
    ActionTarget["REGULAR"] = "ACTION_TARGET_REGULAR";
    ActionTarget["DAY_TRADE"] = "ACTION_TARGET_DAY_TRADE";
    ActionTarget["LEGACY_SMARTORDER"] = "ACTION_TARGET_LEGACY_SMARTORDER";
    ActionTarget["TRAILING_STOP"] = "ACTION_TARGET_TRAILING_STOP";
    ActionTarget["STOP_ORDER"] = "ACTION_TARGET_STOP_ORDER";
    ActionTarget["BRACKET_ORDER"] = "ACTION_TARGET_BRACKET_ORDER";
})(ActionTarget || (ActionTarget = {}));


/***/ }),

/***/ 38525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ withMaintenanceGuard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/lib/stores/trading.ts
var trading = __webpack_require__(76260);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/trading.ts
var instance_trading = __webpack_require__(96563);
;// CONCATENATED MODULE: ./src/global/Securities/api/maintenance.ts




var getMaintenanceStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,instance_trading/* getTradingApiInstance */.j)().get(apiEndpoint/* maintenanceEndpoint.getStatus */.bB.getStatus, {
                        withAccessToken: false
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getMaintenanceStatus() {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/global/Securities/types/api/maintenance.ts
var MaintenanceStatusType;
(function(MaintenanceStatusType) {
    MaintenanceStatusType["Unspecified"] = "STATUS_UNSPECIFIED";
    MaintenanceStatusType["OnMaintenance"] = "STATUS_MAINTENANCE";
    MaintenanceStatusType["NotMaintenance"] = "STATUS_NOT_MAINTENANCE";
})(MaintenanceStatusType || (MaintenanceStatusType = {}));

;// CONCATENATED MODULE: ./src/global/Securities/utils/maintenance.ts





// Modify the function signature to accept arguments
function withMaintenanceGuard(// eslint-disable-next-line @typescript-eslint/ban-types
callback) {
    return _withMaintenanceGuard.apply(this, arguments);
}
function _withMaintenanceGuard() {
    _withMaintenanceGuard = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(callback) {
        var isAllowed, response, _data, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    isAllowed = false;
                    if (isAllowed) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", callback());
                case 4:
                    _ctx.next = 6;
                    return getMaintenanceStatus();
                case 6:
                    response = _ctx.sent;
                    _data = response.data, data = _data.data, message = _data.message;
                    if (!(data.status === MaintenanceStatusType.OnMaintenance)) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", trading/* default.getState */.Z.getState().setErrorCode(503, message, "DAILY_MAINTENANCE_MODE"));
                case 10:
                    return _ctx.abrupt("return", callback());
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", callback());
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return _withMaintenanceGuard.apply(this, arguments);
}


/***/ }),

/***/ 66940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useIsUserSyariah; }
});

// EXTERNAL MODULE: ./src/utils/securitiesLocalStorage.ts + 1 modules
var securitiesLocalStorage = __webpack_require__(11763);
;// CONCATENATED MODULE: ./src/global/Securities/types/api/auth.ts
var AccountTypeEnum;
(function(AccountTypeEnum) {
    AccountTypeEnum["EQUITY"] = "ACCOUNT_TYPE_EQUITY";
    AccountTypeEnum["SYARIAH"] = "ACCOUNT_TYPE_SYARIAH";
    AccountTypeEnum["BOND"] = "ACCOUNT_TYPE_BOND";
    AccountTypeEnum["DAY_TRADING"] = "ACCOUNT_TYPE_DAY_TRADING";
})(AccountTypeEnum || (AccountTypeEnum = {}));

;// CONCATENATED MODULE: ./src/global/TradingModal/hooks/useIsUserSyariah.ts


var useIsSyariahUser = function() {
    var accountType = securitiesLocalStorage/* default.getSecuritiesAccountInfo */.Z.getSecuritiesAccountInfo().accountType;
    return accountType === AccountTypeEnum.SYARIAH;
};
/* harmony default export */ var useIsUserSyariah = (useIsSyariahUser);


/***/ }),

/***/ 47060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var global_TradingModal_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70362);
/* harmony import */ var lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36902);
/* harmony import */ var global_TradingModal_hooks_useIsUserSyariah__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66940);





var useSyariah = function() {
    var setModalState = (0,global_TradingModal_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(s) {
        return s.setModalState;
    });
    var checkStockTradable = (0,lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(s) {
        return s.checkStockTradable;
    });
    var isUserSyariah = (0,global_TradingModal_hooks_useIsUserSyariah__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var checkSyariahTradeableStatus = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol) {
            var data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return checkStockTradable(symbol);
                    case 3:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.is_sharia_tradable);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", true);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function checkSyariahTradeableStatus(symbol) {
            return _ref.apply(this, arguments);
        };
    }();
    var showSyariahRestrictionModal = function() {
        setModalState({
            visible: true,
            modalData: {
                showShariaRestrictionBuy: true
            }
        });
    };
    var hideSyariahRestrictionModal = function() {
        setModalState({
            modalData: {
                showShariaRestrictionBuy: false
            }
        });
    };
    return {
        showSyariahRestrictionModal: showSyariahRestrictionModal,
        hideSyariahRestrictionModal: hideSyariahRestrictionModal,
        checkSyariahTradeableStatus: checkSyariahTradeableStatus,
        isUserSyariah: isUserSyariah
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSyariah);


/***/ }),

/***/ 70362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);
/* eslint-disable import/no-named-as-default-member */ 


var initialState = {
    visible: false,
    symbol: null,
    price: null,
    orderType: null,
    formType: null,
    showOrderbook: true,
    showTabs: false,
    showOrderType: false,
    orderedLot: null,
    orderid: null,
    orderedPrice: null,
    isAutoBuy: false,
    modalData: {},
    onClose: null,
    isDayTrade: false,
    trailingStop: undefined,
    setToMaxLot: false,
    isGtc: undefined
};
var tradingModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setPrice: function(price) {
            set({
                price: price
            });
        },
        showModal: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                visible: true
            }, payload));
        },
        setAutoBuy: function(isAutoBuy) {
            set({
                isAutoBuy: isAutoBuy
            });
        },
        resetModal: function() {
            set(initialState);
        },
        setSymbol: function(symbol) {
            set({
                symbol: symbol
            });
        },
        setOrderType: function(type) {
            set({
                orderType: type
            });
        },
        setModalState: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, payload));
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (tradingModalStore);


/***/ }),

/***/ 64999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71158);
/* harmony import */ var global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20620);


var useTradingAccount = function() {
    var tradingType = (0,global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(s) {
        return s.accountType;
    });
    var isRealTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.REAL */ .Q5.REAL;
    var isVirtualTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.VIRTUAL */ .Q5.VIRTUAL;
    return {
        tradingType: tradingType,
        isRealTrading: isRealTrading,
        isVirtualTrading: isVirtualTrading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTradingAccount);


/***/ }),

/***/ 89237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hc": function() { return /* binding */ convertSmartOrderConfigType; },
/* harmony export */   "KH": function() { return /* binding */ convertSecuritiesKind; },
/* harmony export */   "TQ": function() { return /* binding */ lotFormatter; },
/* harmony export */   "a$": function() { return /* binding */ getExercisedData; },
/* harmony export */   "aF": function() { return /* binding */ getHourFromTimestamp; },
/* harmony export */   "gg": function() { return /* binding */ convertTimestampToDate; },
/* harmony export */   "hK": function() { return /* binding */ getTime; },
/* harmony export */   "y0": function() { return /* binding */ convertBooleanToNumber; },
/* harmony export */   "zn": function() { return /* binding */ convertForceSellEvent; }
/* harmony export */ });
/* unused harmony exports formatToLocalDate, convertGoogleDateToTimestamp */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78343);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42298);
/* harmony import */ var global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91037);


var HOUR_OFFSET = -7;
var convertBooleanToNumber = function(bool) {
    return bool ? 1 : 0;
};
var formatToLocalDate = function(date, customFormat) {
    var adjustedDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(date, HOUR_OFFSET);
    var formattedHour = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(adjustedDate, customFormat);
    return formattedHour;
};
var convertTimestampToDate = function(time) {
    if (!time) return "";
    var jsDate = new Date(time);
    return formatToLocalDate(jsDate, "yyyy-MM-dd HH:mm:ss");
};
var convertGoogleDateToTimestamp = function(date) {
    if (!date) return "";
    var year = date.year, month = date.month, day = date.day;
    var jsDate = new Date(year, month - 1, day + 1);
    return formatToLocalDate(jsDate, "dd-MM-yyyy");
};
var getHourFromTimestamp = function(time) {
    if (!time) return "";
    var jsDate = new Date(time);
    return formatToLocalDate(jsDate, "HH:mm:ss");
};
var getTime = function(timestamp) {
    if (!timestamp) return "";
    return Number(timestamp.seconds) * 1000;
};
var getExercisedData = function(exercise) {
    if (!exercise) return null;
    var active = exercise.active, type = exercise.type, price = exercise.price, info = exercise.info, date = exercise.date;
    return {
        active: active,
        type: type,
        price: price,
        info: info,
        listing_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.listing),
        expired_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.expired),
        mature_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.mature),
        exercise_start_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.start),
        exercise_end_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.end)
    };
};
var convertForceSellEvent = function(event) {
    switch(event){
        case 1:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.DebtRatio */ .pD.DebtRatio;
        case 2:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.TimeLimit */ .pD.TimeLimit;
        default:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.Unspecified */ .pD.Unspecified;
    }
};
var convertSmartOrderConfigType = function(configType) {
    switch(configType){
        case "CONFIG_PRICE_TYPE_ABOVE":
            return "1";
        case "CONFIG_PRICE_TYPE_BELOW":
            return "2";
        default:
            return configType;
    }
};
var convertSecuritiesKind = function(kind) {
    switch(kind){
        case global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .SecuritiesKind.STOCK */ .pY.STOCK:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Stock */ .IC.Stock;
        case global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .SecuritiesKind.BOND */ .pY.BOND:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Bond */ .IC.Bond;
        default:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Unspecified */ .IC.Unspecified;
    }
};
var lotFormatter = function(value) {
    return Intl.NumberFormat("en-US").format(value);
};


/***/ }),

/***/ 75413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export convertSideToAction */
/* harmony import */ var utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89237);
/* harmony import */ var global_Securities_types_api_orderList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75626);
/* harmony import */ var global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91037);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83153);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2078);





var convertSideToAction = function(side) {
    return side === global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_2__/* .OrderSide.Buy */ .oU.Buy ? global_Securities_types_api_orderList__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Buy */ .i.Buy : global_Securities_types_api_orderList__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Sell */ .i.Sell;
};
var portfolioItem = function(data) {
    var ref = data !== null && data !== void 0 ? data : {}, asset = ref.asset, company = ref.company, exercise = ref.exercise, flags = ref.flags, price = ref.price, qty = ref.qty, symbol = ref.symbol, type = ref.type, info = ref.info, bond = ref.bond, can_create_smart_order = ref.can_create_smart_order, is_sharia = ref.is_sharia;
    return {
        allow_order: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertBooleanToNumber */ .y0)(flags === null || flags === void 0 ? void 0 : flags.allow_order),
        amount_invested: asset === null || asset === void 0 ? void 0 : asset.amount_invested,
        available_lot: qty === null || qty === void 0 ? void 0 : qty.available.lot,
        available_share: qty === null || qty === void 0 ? void 0 : qty.available.share,
        balance_lot: qty === null || qty === void 0 ? void 0 : qty.balance.lot,
        balance_share: qty === null || qty === void 0 ? void 0 : qty.balance.share,
        company_name: company === null || company === void 0 ? void 0 : company.name,
        exercise_data: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .getExercisedData */ .a$)(exercise),
        exercise_type: exercise === null || exercise === void 0 ? void 0 : exercise.type,
        have_smartorder: flags === null || flags === void 0 ? void 0 : flags.have_smart_order,
        price_average: price === null || price === void 0 ? void 0 : price.average.price,
        price_average_fee: price === null || price === void 0 ? void 0 : price.average.fee,
        price_latest: price === null || price === void 0 ? void 0 : price.latest,
        stock_on_hand: qty === null || qty === void 0 ? void 0 : qty.stock_on_hand,
        symbol: symbol,
        total: asset === null || asset === void 0 ? void 0 : asset.amount_invested,
        unrealised_gain: asset === null || asset === void 0 ? void 0 : asset.unrealised.gain,
        unrealised_marketvalue: asset === null || asset === void 0 ? void 0 : asset.unrealised.market_value,
        unrealised_profitloss: asset === null || asset === void 0 ? void 0 : asset.unrealised.profit_loss,
        type: type !== null && type !== void 0 ? type : "",
        info: info !== null && info !== void 0 ? info : [],
        bond: bond !== null && bond !== void 0 ? bond : undefined,
        show_create_smartorder: can_create_smart_order !== null && can_create_smart_order !== void 0 ? can_create_smart_order : false,
        can_buy: flags === null || flags === void 0 ? void 0 : flags.can_buy,
        can_sell: flags === null || flags === void 0 ? void 0 : flags.can_sell,
        is_sharia: is_sharia
    };
};
var portfolioItemFromBonds = function(data) {
    var ref, ref1, ref2, ref3;
    return {
        allow_order: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertBooleanToNumber */ .y0)(true),
        amount_invested: data === null || data === void 0 ? void 0 : data.invested_amount,
        available_lot: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        available_share: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        balance_lot: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        balance_share: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        company_name: data.product.name,
        exercise_data: undefined,
        exercise_type: undefined,
        have_smartorder: false,
        price_average: data === null || data === void 0 ? void 0 : data.price_rate,
        price_average_fee: data === null || data === void 0 ? void 0 : data.price_rate,
        price_latest: undefined,
        stock_on_hand: data === null || data === void 0 ? void 0 : data.invested_amount,
        symbol: data === null || data === void 0 ? void 0 : (ref = data.product) === null || ref === void 0 ? void 0 : ref.identifier,
        total: data === null || data === void 0 ? void 0 : data.total_portfolio,
        unrealised_gain: (data === null || data === void 0 ? void 0 : (ref1 = data.profit_loss) === null || ref1 === void 0 ? void 0 : ref1.percentage) / 100,
        unrealised_marketvalue: data === null || data === void 0 ? void 0 : data.market_value,
        unrealised_profitloss: data === null || data === void 0 ? void 0 : (ref2 = data.profit_loss) === null || ref2 === void 0 ? void 0 : ref2.amount,
        type: constants_trading__WEBPACK_IMPORTED_MODULE_3__/* .STOCK_TYPE.bond */ .L2.bond,
        info: undefined,
        bond: undefined,
        show_create_smartorder: false,
        bond_sell_enabled: parseInt(data === null || data === void 0 ? void 0 : data.units, 10) > 0,
        is_sharia: data === null || data === void 0 ? void 0 : (ref3 = data.product) === null || ref3 === void 0 ? void 0 : ref3.is_sharia,
        can_buy: false,
        can_sell: false
    };
};
var portfolioList = function(portfolio) {
    var ref = portfolio !== null && portfolio !== void 0 ? portfolio : {}, summary = ref.summary, smart_order_info = ref.smart_order_info, stockPortfolios = ref.results, day_trade = ref.day_trade;
    var result = stockPortfolios.map(function(stockPortfolio) {
        return portfolioItem(stockPortfolio);
    });
    return {
        tradingbalance: summary === null || summary === void 0 ? void 0 : summary.trading.balance,
        amount_allocated: summary === null || summary === void 0 ? void 0 : summary.amount.allocated,
        amount_creditlimit: summary === null || summary === void 0 ? void 0 : summary.amount.credit_limit,
        unrealised_profitloss: summary === null || summary === void 0 ? void 0 : summary.profit_loss.unrealised,
        realised_profitloss: summary === null || summary === void 0 ? void 0 : summary.profit_loss.realised,
        show_create_smartorder: smart_order_info === null || smart_order_info === void 0 ? void 0 : smart_order_info.can_create,
        auto_order_info: smart_order_info === null || smart_order_info === void 0 ? void 0 : smart_order_info.info,
        day_trade: day_trade === null || day_trade === void 0 ? void 0 : day_trade.map(function(item) {
            return portfolioItem(item);
        }),
        debt_ratio: summary === null || summary === void 0 ? void 0 : summary.debt.ratio,
        debt_total: summary === null || summary === void 0 ? void 0 : summary.debt.total,
        debt_market_value: summary === null || summary === void 0 ? void 0 : summary.debt.market_value,
        amount_invested: summary === null || summary === void 0 ? void 0 : summary.amount.invested,
        gain: summary === null || summary === void 0 ? void 0 : summary.gain,
        profitloss: summary === null || summary === void 0 ? void 0 : summary.profit_loss.net,
        equity: summary === null || summary === void 0 ? void 0 : summary.equity,
        result: result
    };
};
var orderDetail = function(order) {
    var ref;
    var ref1 = order !== null && order !== void 0 ? order : {}, action = ref1.action, amount = ref1.amount, day_trade = ref1.day_trade, gtc = ref1.gtc, market_order_id = ref1.market_order_id, message = ref1.message, order_id = ref1.order_id, price = ref1.price, qty = ref1.qty, side = ref1.side, securities_kind = ref1.securities_kind, smart_order = ref1.smart_order, status_text = ref1.status_text, symbol = ref1.symbol, time = ref1.time, is_sharia = ref1.is_sharia, platform_order_type = ref1.platform_order_type;
    var isBond = securities_kind === "SECURITIES_KIND_BOND";
    var isFAK = platform_order_type === global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_4__/* .PlatformOrderTypes.FAK */ .F4.FAK;
    var gtc_text = "DAY";
    if (isFAK) gtc_text = "FAK";
    else if (gtc === null || gtc === void 0 ? void 0 : gtc.is_gtc) gtc_text = "GTC";
    var ref2, ref3, ref4, ref5, ref6;
    return {
        action: convertSideToAction(side),
        amend_action: action === null || action === void 0 ? void 0 : action.can_amend,
        amend_target: action === null || action === void 0 ? void 0 : action.amend_target,
        amount: amount === null || amount === void 0 ? void 0 : amount.amount,
        amount_fee: amount === null || amount === void 0 ? void 0 : amount.fee.amount,
        amount_invested: amount === null || amount === void 0 ? void 0 : amount.invested,
        amount_invested_fee: isBond ? undefined : amount === null || amount === void 0 ? void 0 : amount.fee.invested,
        amount_matched: isBond ? amount === null || amount === void 0 ? void 0 : (ref = amount.fee) === null || ref === void 0 ? void 0 : ref.invested : amount === null || amount === void 0 ? void 0 : amount.matched,
        amount_matched_broker_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.broker,
        amount_matched_exchange_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.exchange,
        amount_matched_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.amount,
        amount_matched_total: amount === null || amount === void 0 ? void 0 : amount.matched_total,
        amount_open: amount === null || amount === void 0 ? void 0 : amount.open,
        amount_open_fee: amount === null || amount === void 0 ? void 0 : amount.fee.open,
        cancel_action: action === null || action === void 0 ? void 0 : action.can_cancel,
        cancel_target: action === null || action === void 0 ? void 0 : action.cancel_target,
        config_type: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertSmartOrderConfigType */ .Hc)(smart_order === null || smart_order === void 0 ? void 0 : smart_order.config_type),
        gtc_text: gtc_text,
        gtc: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertBooleanToNumber */ .y0)(gtc === null || gtc === void 0 ? void 0 : gtc.is_gtc),
        label: isFAK ? "MO" : smart_order === null || smart_order === void 0 ? void 0 : smart_order.label,
        market_orderid: market_order_id,
        message: message,
        order_done: isBond ? undefined : qty === null || qty === void 0 ? void 0 : qty.lot_done,
        order_open: qty === null || qty === void 0 ? void 0 : qty.lot_open,
        order_total: isBond ? undefined : qty === null || qty === void 0 ? void 0 : qty.lot_total,
        orderid: order_id,
        price: price === null || price === void 0 ? void 0 : price.order,
        price_average: price === null || price === void 0 ? void 0 : price.average.price,
        price_average_fee: price === null || price === void 0 ? void 0 : price.average.fee,
        price_average_portfolio: price === null || price === void 0 ? void 0 : price.average.portfolio,
        price_order: price === null || price === void 0 ? void 0 : price.order,
        smart_orderid: (ref2 = smart_order === null || smart_order === void 0 ? void 0 : smart_order.order_id) !== null && ref2 !== void 0 ? ref2 : smart_order === null || smart_order === void 0 ? void 0 : smart_order.id,
        status: status_text,
        symbol: symbol,
        securities_kind: securities_kind,
        time: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .getHourFromTimestamp */ .aF)((ref3 = time === null || time === void 0 ? void 0 : time.open) !== null && ref3 !== void 0 ? ref3 : time === null || time === void 0 ? void 0 : time.opened_at),
        time_match: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertTimestampToDate */ .gg)((ref4 = time === null || time === void 0 ? void 0 : time.match) !== null && ref4 !== void 0 ? ref4 : time === null || time === void 0 ? void 0 : time.matched_at),
        time_open: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertTimestampToDate */ .gg)((ref5 = time === null || time === void 0 ? void 0 : time.open) !== null && ref5 !== void 0 ? ref5 : time === null || time === void 0 ? void 0 : time.opened_at),
        trigger_price: smart_order === null || smart_order === void 0 ? void 0 : smart_order.trigger_price,
        day_trade_is_day_trade: day_trade === null || day_trade === void 0 ? void 0 : day_trade.is_day_trade,
        day_trade_force_sell_event: day_trade === null || day_trade === void 0 ? void 0 : day_trade.force_sell_event,
        day_trade_message: (ref6 = day_trade === null || day_trade === void 0 ? void 0 : day_trade.message) !== null && ref6 !== void 0 ? ref6 : "",
        is_sharia: is_sharia,
        trailing_stop: smart_order === null || smart_order === void 0 ? void 0 : smart_order.trailing_stop,
        platform_order_type: platform_order_type
    };
};
var orderList = function(orders) {
    var mappedData = orders === null || orders === void 0 ? void 0 : orders.map(function(order) {
        return orderDetail(order);
    });
    return mappedData;
};
var formulaData = function(data) {
    var ref = data !== null && data !== void 0 ? data : {}, version = ref.version, formula = ref.formula, fee = ref.fee, preview_fee = ref.preview_fee, day_trade = ref.day_trade;
    var dayTradePreviewFee = (day_trade === null || day_trade === void 0 ? void 0 : day_trade.preview_fee) ? day_trade.preview_fee : preview_fee;
    return {
        version: version,
        fee: {
            buy: fee.buy,
            sell: fee.sell
        },
        formula: {
            buy_amount_broker_fee: formula.buy.broker_fee,
            buy_amount_exchange_fee: formula.buy.exchange_fee,
            buy_amount_fee: formula.buy.fee,
            buy_amount_invested: formula.buy.invested,
            buy_amount_invested_fee: formula.buy.invested_fee,
            ca_sell_amount_broker_fee: formula.ca_sell.broker_fee,
            ca_sell_amount_exchange_fee: formula.ca_sell.exchange_fee,
            ca_sell_amount_fee: formula.ca_sell.fee,
            ca_sell_amount_invested: formula.ca_sell.invested,
            ca_sell_amount_invested_fee: formula.ca_sell.invested_fee,
            sell_amount_broker_fee: formula.sell.broker_fee,
            sell_amount_exchange_fee: formula.sell.exchange_fee,
            sell_amount_fee: formula.sell.fee,
            sell_amount_invested: formula.sell.invested,
            sell_amount_invested_fee: formula.sell.invested_fee,
            sell_gain: formula.sell_gain,
            sell_profit_loss: formula.sell_profit_loss,
            amount_invested: formula.amount_invested,
            summary_equity: formula.summary.equity,
            summary_invested: formula.summary.invested,
            summary_net_profit_loss: formula.summary.net_profit_loss.value,
            summary_net_profit_loss_percentage: formula.summary.net_profit_loss.percentage,
            unrealised_gain: formula.unrealized.gain,
            unrealised_market_value: formula.unrealized.market_value,
            unrealised_profit_loss: formula.unrealized.profit_loss,
            day_trade_debt_ratio: formula.day_trade.debt.ratio,
            day_trade_debt_unrealized: formula.day_trade.debt.unrealized,
            day_trade_portion_order_amount: formula.day_trade.portion_order_amount,
            day_trade_investment_day_trade: formula.day_trade.investment.day_trade,
            day_trade_investment_portion_tb: formula.day_trade.investment.portion_tb,
            fee_buy: fee.buy,
            fee_sell: fee.sell,
            fee_buy_day_trade: day_trade.fee.buy,
            fee_sell_day_trade: day_trade.fee.sell
        },
        preview_fee: {
            broker_fee: preview_fee.broker_fee,
            exchange: {
                compositions: preview_fee.exchange.compositions,
                title: preview_fee.exchange.title,
                desc: preview_fee.exchange.desc,
                subtitle: preview_fee.exchange.subtitle,
                exchange_fee_total_buy: preview_fee.exchange.total_buy,
                exchange_fee_total_ca_buy: preview_fee.exchange.total_ca_buy,
                exchange_fee_total_ca_sell: preview_fee.exchange.total_ca_sell,
                exchange_fee_total_sell: preview_fee.exchange.total_sell,
                exchange_fee_total_title: preview_fee.exchange.total_title
            }
        },
        day_trade: {
            fee: {
                buy: day_trade.fee.buy,
                sell: day_trade.fee.sell
            },
            portion_deduct_to_tb: day_trade.portion_deduct_to_tb,
            preview_fee: {
                broker_fee: dayTradePreviewFee.broker_fee,
                exchange: {
                    compositions: dayTradePreviewFee.exchange.compositions,
                    title: dayTradePreviewFee.exchange.title,
                    desc: dayTradePreviewFee.exchange.desc,
                    subtitle: dayTradePreviewFee.exchange.subtitle,
                    exchange_fee_total_buy: dayTradePreviewFee.exchange.total_buy,
                    exchange_fee_total_ca_buy: dayTradePreviewFee.exchange.total_ca_buy,
                    exchange_fee_total_ca_sell: dayTradePreviewFee.exchange.total_ca_sell,
                    exchange_fee_total_sell: dayTradePreviewFee.exchange.total_sell,
                    exchange_fee_total_title: dayTradePreviewFee.exchange.total_title
                }
            }
        }
    };
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    portfolioItem: portfolioItem,
    portfolioList: portfolioList,
    orderDetail: orderDetail,
    orderList: orderList,
    formulaData: formulaData,
    portfolioItemFromBonds: portfolioItemFromBonds
});


/***/ }),

/***/ 20:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/backpack/1.0.0/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["backpack"]) {
      return resolve(window.remoteLoading["backpack"])
    }

    var res, rej;
    window.remoteLoading["backpack"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["backpack"] !== 'undefined') {
      res(window["backpack"]);
      return resolve(window["backpack"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["backpack"] !== 'undefined') {
          res(window["backpack"]);
          return resolve(window["backpack"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "backpack"
    );
  }).then(function () {
    const proxy = {
      get: backpack.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          backpack.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        backpack.__initialized = true
      }
    }
    if (!backpack.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 92064:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/buy-sell/1.5.8/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["buysell"]) {
      return resolve(window.remoteLoading["buysell"])
    }

    var res, rej;
    window.remoteLoading["buysell"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["buysell"] !== 'undefined') {
      res(window["buysell"]);
      return resolve(window["buysell"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["buysell"] !== 'undefined') {
          res(window["buysell"]);
          return resolve(window["buysell"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "buysell"
    );
  }).then(function () {
    const proxy = {
      get: buysell.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          buysell.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        buysell.__initialized = true
      }
    }
    if (!buysell.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 35518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/eipo/1.1.5/static/chunks/moduleEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["stockbitipo"]) {
      return resolve(window.remoteLoading["stockbitipo"])
    }

    var res, rej;
    window.remoteLoading["stockbitipo"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["stockbitipo"] !== 'undefined') {
      res(window["stockbitipo"]);
      return resolve(window["stockbitipo"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["stockbitipo"] !== 'undefined') {
          res(window["stockbitipo"]);
          return resolve(window["stockbitipo"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "stockbitipo"
    );
  }).then(function () {
    const proxy = {
      get: stockbitipo.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          stockbitipo.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        stockbitipo.__initialized = true
      }
    }
    if (!stockbitipo.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 94673:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/fast-trade/1.1.6/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["fasttrade"]) {
      return resolve(window.remoteLoading["fasttrade"])
    }

    var res, rej;
    window.remoteLoading["fasttrade"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["fasttrade"] !== 'undefined') {
      res(window["fasttrade"]);
      return resolve(window["fasttrade"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["fasttrade"] !== 'undefined') {
          res(window["fasttrade"]);
          return resolve(window["fasttrade"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "fasttrade"
    );
  }).then(function () {
    const proxy = {
      get: fasttrade.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          fasttrade.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        fasttrade.__initialized = true
      }
    }
    if (!fasttrade.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 2680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/movers/1.0.2/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["movers"]) {
      return resolve(window.remoteLoading["movers"])
    }

    var res, rej;
    window.remoteLoading["movers"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["movers"] !== 'undefined') {
      res(window["movers"]);
      return resolve(window["movers"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["movers"] !== 'undefined') {
          res(window["movers"]);
          return resolve(window["movers"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "movers"
    );
  }).then(function () {
    const proxy = {
      get: movers.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          movers.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        movers.__initialized = true
      }
    }
    if (!movers.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 85611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/top-stocks/1.0.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["topstocks"]) {
      return resolve(window.remoteLoading["topstocks"])
    }

    var res, rej;
    window.remoteLoading["topstocks"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["topstocks"] !== 'undefined') {
      res(window["topstocks"]);
      return resolve(window["topstocks"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["topstocks"] !== 'undefined') {
          res(window["topstocks"]);
          return resolve(window["topstocks"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "topstocks"
    );
  }).then(function () {
    const proxy = {
      get: topstocks.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          topstocks.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        topstocks.__initialized = true
      }
    }
    if (!topstocks.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [74885,63332,25287,94119,78656,71577,75819,88069,46819,7648,25935,51225,80129,40142,80737,77549,54253,54005,91036,33070,42298,61980,98294,46231,81770,44912,62571,21671,74768,40927,77284,36902,59765,49774,92888,40179], function() { return __webpack_exec__(61748); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);